module.exports = __webpack_public_path__ + "static/media/lyrice-app-min.ee97b9a1.png";